export const Kind = 'NOTE' as const;

export enum Status {
  Init = 'INIT',
  Fetching = 'FETCHING',
  Todo = 'TODO',
  // new statuses
  Transcribing = 'TRANSCRIBING',
  TranscribingNeedsReview = 'TRANSCRIBING_NEEDS_REVIEW',
  LabelingPending = 'LABELING_PENDING',
  Labeling = 'LABELING',
  LabelingNeedsReview = 'LABELING_NEEDS_REVIEW',
  Structuring = 'STRUCTURING',
  StructuringNeedsReview = 'STRUCTURING_NEEDS_REVIEW',
  Resolving = 'RESOLVING',
  ResolvingNeedsReview = 'RESOLVING_NEEDS_REVIEW',
  // export statuses
  Exporting = 'EXPORTING',
  ExportingManually = 'EXPORTING_MANUALLY',
  ExportNeedsReview = 'EXPORT_NEEDS_REVIEW',
  ExportedSuccessfully = 'EXPORTED_SUCCESSFULLY',
  ExportedManually = 'EXPORTED_MANUALLY',
  NoAudio = 'NO_AUDIO',
}
